import { format } from 'date-fns';
import { ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Icon } from 'rsuite';

import { endLinkAccessSession, getLinkAccessSession } from '../../utils/linkAccessSession';
import styles from './LinkAccessBanner.module.scss';
import { useFixedWarningOffset } from './useFixedWarningOffset';

const getClientName = () => {
  try {
    const client: unknown = JSON.parse(localStorage.getItem('cliente') ?? 'null');
    return (client as { nome?: string } | null)?.nome ?? '';
  } catch {
    return '';
  }
};

type LinkAccessBannerProps = {
  children?: ReactNode;
};

export const LinkAccessBanner = ({ children }: LinkAccessBannerProps) => {
  const history = useHistory();
  const [session, setSession] = useState(getLinkAccessSession);
  const layoutRef = useRef<HTMLDivElement>(null);
  useFixedWarningOffset(layoutRef, Boolean(session));

  const handleSignOut = useCallback(() => {
    endLinkAccessSession();
    setSession(null);
    history.push('/login');
  }, [history]);

  useEffect(() => {
    if (!session) return undefined;
    const timeout = setTimeout(handleSignOut, Math.max(session.expiraEm - Date.now(), 0));
    return () => clearTimeout(timeout);
  }, [session, handleSignOut]);

  if (!session) return <>{children}</>;

  const clientName = getClientName();

  return (
    <div className={styles.layout} ref={layoutRef}>
      <div className={styles.banner} role="status">
        <Icon icon="link" className={styles.icon} />
        <span className={styles.label}>Acesso por link ao cliente</span>
        <strong className={styles.client} title={clientName}>
          {clientName}
        </strong>
        <span className={styles.expiration}>Expira às {format(session.expiraEm, 'HH:mm')}</span>
        <Button size="xs" appearance="ghost" className={styles.signOut} onClick={handleSignOut}>
          Sair
        </Button>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
